// seriesVisibility.ts — pure toggle-state helper backing the interactive chart legends
// (SimulationChart's Marktwert/Anschaffungskosten/Verrechnungskonto lines, the Vergleich
// overlay chart's per-scenario lines). A tiny standalone module — rather than an inline
// useState updater in each chart component — so the on/off logic is unit-testable
// without mounting a chart/uPlot instance (this repo's web tests run in a DOM-less "node"
// vitest environment, see vite.config.ts).
export type SeriesVisibility = Record<string, boolean>;

/** A key defaults to visible until it's been explicitly toggled off — so a brand-new
 * series (e.g. a scenario just added to the Vergleich selection) starts visible without
 * needing to be seeded into the map first. */
export function isSeriesVisible(visibility: SeriesVisibility, key: string): boolean {
  return visibility[key] !== false;
}

export function toggleSeriesVisibility(visibility: SeriesVisibility, key: string): SeriesVisibility {
  return { ...visibility, [key]: !isSeriesVisible(visibility, key) };
}
